import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

// CAUTION: This is only temporary and may fail in the future if Safari changes their private mode behavior
export const useAppStateStore = create(
  subscribeWithSelector((set, get) => ({
    isSafariPrivate: false,
    openSidebar: false,
  })),
);
